import PropTypes from 'prop-types';
import React from 'react';

export const Input = React.forwardRef(({ styles, inputId, label, value, onChange, placeholder, name, autoComplete = "off", maxLength = null }, ref) => {
    return (
        <div className={styles}>
            <div className="form-group">
                <label htmlFor={inputId} className="label-oscura">{label}</label>
                <input
                    id={inputId}
                    type="text"
                    className="form-control"
                    value={value || ""}
                    onChange={onChange}
                    placeholder={placeholder}
                    name={name}
                    autoComplete={autoComplete}
                    ref={ref}
                    maxLength={maxLength}
                />
            </div>
        </div>
    );
});
Input.propTypes = {
    styles: PropTypes.string,
    inputId: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    name: PropTypes.string,
    autoComplete: PropTypes.string,
    maxLength: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}